import React, { useContext } from 'react';
import { Environment } from 'src/Environment';
import { OnboardingComplete } from 'src/features/onboarding/components/onboarding-complete/onboarding-complete';
import { OnboardingCompleteRevamp } from 'src/features/onboarding/components/onboarding-complete/onboarding-complete-revamp';
import { OnboardingFica } from 'src/features/onboarding/components/onboarding-fica/onboarding-fica';
import { ApplicationContext } from 'src/features/onboarding/context';
import { CardType } from 'src/features/onboarding/pages/setup-completion/setup-completion';

interface Props {
  cards: CardType[];
}

export function CompleteApplication({ cards }: Props) {
  const { application } = useContext(ApplicationContext);
  const [ficaSuccessful, setFicaSuccessful] = React.useState(false);

  const revampEnabled = React.useMemo(
    (): boolean => !Environment.current.disabledFeatures.revamp,
    [],
  );

  return application.agentJourney && !ficaSuccessful ? (
    <OnboardingFica setFicaSuccessful={setFicaSuccessful} />
  ) : (
    <>
      {revampEnabled ? (
        <OnboardingCompleteRevamp cards={cards} />
      ) : (
        <OnboardingComplete cards={cards} />
      )}
    </>
  );
}
